<template>
  <app-modal ref="modal" close-on-backdrop-click>
    <nexultra-l-marketing-campaign :unit-price="unitPrice" :threshold-amount="thresholdAmount" />
  </app-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import AppModal from '@/components/common/AppModal.vue';
import NexultraLMarketingCampaign from '@/components/nexultra-l-marketing-campaign/NexultraLMarketingCampaign.vue';

import { getCountryCurrency } from '@/utils/common';
import { getNexultraMarketingCampaign } from '@/api';

import { Price } from '@/models/core/values';

import { PRODUCT_REFERENCES } from '@/constants/treatment';
import { types } from '@/store/types';

const NEXULTRA_THRESHOLD = {
  EUR: Price(100, 'EUR'),
  GBP: Price(100, 'GBP'),
  CHF: Price(100, 'CHF'),
  PLN: Price(500, 'PLN'),
  DKK: Price(750, 'DKK'),
  SEK: Price(1000, 'SEK'),
  BGN: Price(200, 'BGN'),
  RON: Price(500, 'RON'),
  HUF: Price(30000, 'HUF'),
  HRK: Price(750, 'HRK')
};

export const getNexultraMarketingCampaignData = async ({ deliveryCountry, prices }) => {
  const currency = getCountryCurrency(deliveryCountry);
  const thresholdAmount = NEXULTRA_THRESHOLD[currency];
  const { productPrices } = prices;
  const priceData = productPrices.find(
    ({ reference }) => reference === PRODUCT_REFERENCES.NEXULTRA_L1
  );

  if (!priceData) {
    return {};
  }

  return {
    thresholdAmount,
    unitPrice: Price(priceData.chosenPrice, currency)
  };
};

const HAS_BEEN_SHOWN_SESSION_STORAGE_KEY = 'nexultraPopupHasBeenShown';

export default {
  name: 'NexultraMarketingCampaignModal',
  components: { AppModal, NexultraLMarketingCampaign },
  data() {
    return { thresholdAmount: null, unitPrice: null, timer: null };
  },
  computed: {
    ...mapState({
      prices: types.state.PRICES
    }),
    ...mapGetters({
      deliveryCountry: types.getters.DELIVERY_COUNTRY
    })
  },
  watch: {
    deliveryCountry: 'updateNexultraCampaignData',
    prices: 'updateNexultraCampaignData'
  },
  mounted() {
    if (this.hasPopupBeenShown()) {
      return;
    }

    this.updateNexultraCampaignData();
    this.scheduleOpening();
  },
  beforeDestroy() {
    this.descheduleOpening();
  },
  methods: {
    hasPopupBeenShown() {
      return !!sessionStorage.getItem(HAS_BEEN_SHOWN_SESSION_STORAGE_KEY);
    },
    open() {
      if (this.$refs.modal) {
        sessionStorage.setItem(HAS_BEEN_SHOWN_SESSION_STORAGE_KEY, 'true');

        return this.$refs.modal.open();
      }

      return null;
    },
    async updateNexultraCampaignData() {
      const { deliveryCountry, prices } = this;

      if (!deliveryCountry || !prices) {
        return;
      }

      const { thresholdAmount, unitPrice } = await getNexultraMarketingCampaignData({
        deliveryCountry,
        prices
      });

      this.thresholdAmount = thresholdAmount;
      this.unitPrice = unitPrice;
    },
    descheduleOpening() {
      clearTimeout(this.timer);
    },
    async scheduleOpening() {
      if (!this.thresholdAmount || !this.unitPrice) {
        this.timer = setTimeout(this.scheduleOpening, 0);

        return;
      }

      const { data } = await getNexultraMarketingCampaign(this.deliveryCountry);

      if (!data.active) {
        return;
      }

      this.timer = setTimeout(() => {
        this.open();
      }, 2000);
    }
  }
};
</script>
